module.exports = __webpack_public_path__ + "img/bg_judicial_01.633cf42a.jpg";